export default __webpack_public_path__ + "static/media/dj.a3273c03.svg";